module.exports = {
  "country": "NL",
  "artist": "The Common Linnets",
  "song": "Calms After Storm",
  "year": "2014",
  "place": "2",
  "spotify": "6C2GZHFFO8uXuMYCHiW5Y4"
};